import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as env from 'environments/environment';


@Injectable()
export class DataCollectorService {

    public get baseUrl(): string {
        return `${localStorage.getItem('dc_workflow_builder_url')}/api`
    }

    public get socketUrl(): string {
        return `${localStorage.getItem('dc_workflow_builder_url')}`
    }

    public get gateKeeprUrl(): string {
        return `${localStorage.getItem('dc_workflow_builder_url')}/api/gatekeeper/`
    }

    constructor(private _httpClient: HttpClient) {
    }

    public getdcURL(): Observable<any> {
        return this._httpClient.post(env.environment.workflowBuilder.dcBaseURL+'/config', {
            company_name: 'zuper'
        });
    }

    public getData(url: string, params?: any): Observable<any> {
        return this._httpClient.get(url, {
            params
        });
    }

    public postData(url: string, payload: any, options?: any): Observable<any> {
        return this._httpClient.post(url, payload, options);
    }

    public putData(url: string, payload: any, options?: any): Observable<any> {
        return this._httpClient.put(url, payload, options);
    }

    public deleteData(url: string, params?: any): Observable<any> {
        return this._httpClient.delete(url, {params});
    }
}
